(function inbentaFaq() {
  const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
  const compName = "inbenta-faq";
  const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }


  const inbentaApi = GlobalSite.checkDependency("GlobalSite.inbentaApi");
  const searchEngineUi = GlobalSite.checkDependency("GlobalSite.searchEngineUi");
  const answerBlockUi = GlobalSite.checkDependency("GlobalSite.answerBlockUi");
  const scrollSearchbar = GlobalSite.checkDependency("GlobalSite.scrollSearchbar");
  const getUrlParam = GlobalSite.checkDependency('GlobalSite.getUrlParam');

  $(async () => {
    const searchInput = $(".inbenta-faq__wrapper .search");
    const submitInput = $(".inbenta-faq__wrapper .submit");
    const deleteButton = $(".inbenta-faq__wrapper .delete-btn");
    const autocomplete = $(".inbenta-autocomplete");
    const urlParam = getUrlParam("q");

    if (urlParam) {
      searchInput.val(urlParam);
      submitInput.prop("disabled", false);
    }

    const inbentaAuth = await inbentaApi.auth();

    if (inbentaAuth && urlParam) {
      setTimeout(() => {
        submitInput.click()
        submitInput.blur()
      }, 200)
    }

    inbentaAuth && searchEngineUi([searchInput, submitInput, deleteButton, autocomplete], "faq");
    const popularAnswers = await inbentaApi.getPopular("faq");

    if (!urlParam) {
      inbentaAuth && answerBlockUi("popular", popularAnswers?.results, "faq");
    }

    const listItems = document.querySelector(".inbenta-faq-list-items");
    const results = document.querySelector(".inbenta-faq__results");

    const observerListItems = new MutationObserver(() => {
      const items = document.querySelectorAll(".inbenta-faq-list-items .inbenta-faq-list-item");
      const showMore = document.querySelector(".inbenta-faq__results-more");
      const imageRight = document.querySelector(".inbenta-faq__image-right");
      const resultsInfosNbr = document.querySelector(".inbenta-faq__results-infos-nbr span");
      const resultsInfosText = document.querySelector(".inbenta-faq__results-infos-txt");
      const errorInfos = document.querySelector(".inbenta-faq__results-error");
      const errorsInfosText = document.querySelector(".inbenta-faq__results-error-title span");
      const hasPopular = document.querySelector(".popular");

      if ((items.length > 0) && !hasPopular) {
        results.classList.remove("hide");
        errorInfos.classList.add("hide");

        if (imageRight) {
          imageRight.classList.remove("hide");
        }

        resultsInfosNbr.textContent = items.length;
        resultsInfosText.textContent = `“${searchInput.val()}”`;
      } else if (items.length <= 0) {
        results.classList.add("hide");
        errorInfos.classList.remove("hide");

              answerBlockUi("popular", popularAnswers?.results, "faq");
        resultsInfosText.textContent = "";

                if (imageRight) {   
          imageRight.classList.add("hide");
        }

        errorsInfosText.textContent = `“${searchInput.val()}”`;
      }

      if (items.length > 5) {
        showMore.classList.remove("hide");
      } else {
        showMore.classList.add("hide");
      }
    });

    observerListItems.observe(listItems, {
      subtree: true,
      childList: true,
      attributes: true,
    });

    scrollSearchbar({
      classNamePrefix: "inbenta-faq",
      offsetInput: 60
    })
  });
})();
